import { useCallback, useContext, useEffect } from "react"
import { getArticle } from "../services/ArticleService"
import { useLocation, useNavigate } from "react-router-dom";
import { MODAL_DESCRIPTION_ERROR_ARTICLE_NOT_FOUND, MODAL_MESSAGE_ERROR, MODAL_TYPE_ERROR } from "../HistoriografijaConstants";
import ArticlesContext from "../context/ArticlesContext";
import { useModalContext } from "../context/ModalContext";
import { setError } from "../context/ArticlesContextActions";

function ArticleRedirect() {
    const location = useLocation()
    const queryParams = new URLSearchParams(location.search)
    const articleId = queryParams.get('id')
    const {displayGenericErrorModal, displayMessageModalWithParameters, resetModalContext} = useModalContext()
    const navigate = useNavigate()
    const {dispatch} = useContext(ArticlesContext)

    const handleException = useCallback((error) => {
        dispatch(setError(MODAL_DESCRIPTION_ERROR_ARTICLE_NOT_FOUND))
        if (error.response.status === 404) {
            displayMessageModalWithParameters(MODAL_MESSAGE_ERROR, MODAL_DESCRIPTION_ERROR_ARTICLE_NOT_FOUND, MODAL_TYPE_ERROR)
        } else displayGenericErrorModal()
        return
    }, [])

    useEffect(() => {
        getArticle(articleId)
        .then(article => {
            navigate('/' + article.url, {state: {article: article}})
        })
        .catch(error => {
            handleException(error)
            // Redirect the user to home page after 3 seconds
            setTimeout(() => {
                navigate('/')
                resetModalContext()
            }, 3000)
        })
    }, [window.location.pathname])
}

export default ArticleRedirect